module.exports = __webpack_public_path__ + "img/18.8041c6b5.jpg";